import { GetMyReportsExecutionHistoryDto } from "@/Schemas/Reports/GetMyReportsExecutionHistoryDto";
import { Box, Tab, Tabs, Typography, useTheme } from "@mui/material"
import { useState } from "react";
import { IoMdInformationCircleOutline } from "react-icons/io";
import { IoCloudDownloadOutline, IoServerOutline } from "react-icons/io5";
import { IconType } from "react-icons/lib";
import { AssemblyDetail } from "./AssemblyDetail";
import { AssemblyData } from "./AssemblyData";
import { FilesToDownload } from "./FilesToDownload";

export enum TabType {
    DETAIL = 0,
    DATA = 1,
    FILES_TO_DOWNLOAD = 2,
}

type TabData = {
    label: string;
    icon: IconType;
    type: TabType;
}

export type RunnedAssemblyProps = {
    report: GetMyReportsExecutionHistoryDto;
    initialTab?: TabType;
}


export const RunnedAssembly = (props: RunnedAssemblyProps) => {
    const theme = useTheme();

    const [selectedTab, setSelectedTab] = useState<TabType>(props.initialTab || TabType.DETAIL);

    const tabs: TabData[] = [
        {
            label: "Detail zostavy",
            icon: IoMdInformationCircleOutline,
            type: TabType.DETAIL,
        },
        {
            label: "Dáta spustenej zostavy",
            icon: IoServerOutline,
            type: TabType.DATA,
        },
        {
            label: "Súbory na stiahnutie",
            icon: IoCloudDownloadOutline,
            type: TabType.FILES_TO_DOWNLOAD,
        }
    ]

    return (
        <Box sx={{ display: "flex", flexDirection: "column", flexGrow: 1, height: "100%" }}>
            {!props.report.errorMessage && (
                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                    <Tabs
                        value={selectedTab}
                        onChange={(_event, newValue) => setSelectedTab(newValue)}
                        scrollButtons="auto"
                        allowScrollButtonsMobile
                        variant="scrollable"
                    >
                        {tabs.map((tab) => (
                            <Tab
                                key={tab.type}
                                label={<Typography
                                    variant="subtitle2"
                                    fontSize={15}
                                    color={selectedTab === tab.type ? theme.palette.primary.main : theme.palette.text.secondary}
                                >{tab.label}</Typography>}
                                icon={<tab.icon fontSize={20} />}
                                iconPosition="start"
                                value={tab.type}
                            />
                        ))}
                    </Tabs>
                </Box>
            )}

            {selectedTab === TabType.DETAIL && (
                <AssemblyDetail executedReport={props.report} />
            )}

            {selectedTab === TabType.DATA && (
                <AssemblyData executedReport={props.report} />
            )}

            {selectedTab === TabType.FILES_TO_DOWNLOAD && (
                <FilesToDownload executedReport={props.report} />
            )}
        </Box>
    )
}